import { siteInfo } from "@/mocks/homeData";

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer id="footer" className="bg-background-900 text-foreground-300">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 font-extrabold text-xs">
                黄桃
              </span>
              <span className="text-lg font-bold text-foreground-50 font-heading">
                {siteInfo.name}
              </span>
            </div>
            <p className="text-sm leading-relaxed text-foreground-400">
              专注提供91视频、97视频同级别高清流畅在线播放体验，不缓冲不卡顿，极速加载，畅享高清视界。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4 uppercase tracking-wider">
              快速导航
            </h3>
            <ul className="space-y-3">
              {siteInfo.navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors whitespace-nowrap cursor-pointer no-underline"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4 uppercase tracking-wider">
              内容分类
            </h3>
            <ul className="space-y-3">
              <li><span className="text-sm text-foreground-400">电影</span></li>
              <li><span className="text-sm text-foreground-400">电视剧</span></li>
              <li><span className="text-sm text-foreground-400">综艺</span></li>
              <li><span className="text-sm text-foreground-400">动漫</span></li>
              <li><span className="text-sm text-foreground-400">纪录片</span></li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-200 mb-4 uppercase tracking-wider">
              合作伙伴
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed">
              诚邀优质内容方与技术伙伴加入生态共建，共同打造新一代高清流畅观影平台。
            </p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {year} 黄桃视频 huangtao.video — 不缓冲 · 不卡顿 · 极速高清
          </p>
          <div className="flex items-center gap-6">
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">
              服务条款
            </span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">
              隐私政策
            </span>
            <span className="text-xs text-foreground-500 cursor-pointer hover:text-foreground-300 transition-colors">
              内容声明
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}